import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputSelect from '../../commons/form/InputSelect'
import InputText from '../../commons/form/InputText'
import { mastersTabIndex } from '../../../constants/components/mastersTabIndex'
import ProcessingManagerMasterPageModal from '../../../containers/masters/ProcessingManager/ProcessingManagerMasterPageModal'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class ProcessingManagerMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        organizedUnitId: null,
        name: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchOrganizedUnitsAll()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.eventKey && prevProps.eventKey !== this.props.eventKey && this.props.eventKey === mastersTabIndex.processingManagerMasterPage) {
      this.props.initialize({})
      this.resetFilters()
    }

    if (this.props.ouIdFromMaster != null) {
      const form = {
        filters: {
          organizedUnitId: this.props.ouIdFromMaster
        }
      }
      this.props.initialize(form)
      this.handleOrganizedUnitComboChange(this.props.ouIdFromMaster)
      this.props.actions.setChangeTabFromConfMaster(null, false)
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.setProcessingAgencyManagerFilter({
          orderBy: `-${field}`
        })
        break
      default:
        this.props.actions.setProcessingAgencyManagerFilter({
          orderBy: `+${field}`
        })
        break
    }
  }

  handleNameChange (name) {
    if (this.state.filter.name !== name) {
      this.setState({ filter: { ...this.state.filter, name } })
      this.props.actions.setProcessingAgencyManagerFilter({ name: name })
    }
  }

  handleOrganizedUnitComboChange (organizedUnitId) {
    if (this.state.filter.organizedUnitId !== organizedUnitId) {
      this.setState({ filter: { ...this.state.filter, organizedUnitId } })
      this.props.actions.setProcessingAgencyManagerFilter({ uoId: organizedUnitId })
    }
  }

  search () {
    this.props.actions.fetchProcessingManagersByNameOrUo(this.state.filter.name, this.state.filter.organizedUnitId)
  }

  searchTable (value) {
    this.props.actions.setProcessingAgencyManagerFilter({
      page: value
    })
  }

  editProcessingManager (processingManager) {
    this.props.actions.showProcessingManagerModal(processingManager)
  }

  createProcessingManager () {
    this.props.actions.showProcessingManagerModal(null)
  }

  deleteProcessingManager (processingManager) {
    this.props.actions.deleteProcessingManager(processingManager.processingAgencyManagerId)
  }

  recoverProcessingManager (processingManager) {
    this.props.actions.recoverProcessingManagerModal(processingManager.processingAgencyManagerId)
  }

  paginateAndSortArray (processingManagers, page, pageSize, orderBy) {
    page = parseInt(page) || 1
    pageSize = parseInt(pageSize) || 10

    const clonedArray = [...processingManagers]
    const propToSort = orderBy || 'name'

    if (propToSort.includes('processingAgencyIds')) {
      clonedArray.sort((a, b) => {
        const propToSort = orderBy || 'name'

        if (propToSort.startsWith('-')) {
          return b.processingAgencyIds.length - a.processingAgencyIds.length
        } else {
          return a.processingAgencyIds.length - b.processingAgencyIds.length
        }
      })
    } else {
      const prop = propToSort.replace(/^[-+]/, '')
      const order = propToSort.startsWith('-') ? 'desc' : 'asc'
      clonedArray.sort((a, b) => {
        const valorA = a[prop].toUpperCase()
        const valorB = b[prop].toUpperCase()

        const compare = order === 'asc' ? 1 : -1

        if (valorA < valorB) {
          return -1 * compare
        }
        if (valorA > valorB) {
          return 1 * compare
        }

        return 0
      })
    }

    const startIndex = (page - 1) * pageSize
    const endIndex = startIndex + pageSize
    const paginatedArray = clonedArray.slice(startIndex, endIndex)

    return paginatedArray
  }

  resetFilters () {
    this.setState({
      filter: {
        organizedUnitId: null,
        name: null
      }
    }, () => {
      this.props.actions.setProcessingAgencyManagerFilter({
        page: 1,
        orderBy: '',
        pageSize: 10,
        name: '',
        uoId: null
      })
      this.search()
    })
  }

  render () {
    const {
      t, pagesCount, itemCount, processingManagers,
      combos: { organizedUnitsAllCombo },
      filter: { page, pageSize, orderBy }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'processingManagerMasterPage' })
    const tKey = 'MASTERS.PROCESSING_MANAGER.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip placement='left' id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)
    const recoverTooltip = (<Tooltip placement='left' id="deleteTooltip">{t('MASTERS.RECOVER')}</Tooltip>)
    const hasFilters = (this.state.filter.name || this.state.filter.organizedUnitId)

    let processingManagersSorted = this.paginateAndSortArray(processingManagers || [], page, pageSize, orderBy)
    return (
      <>
        <div id='processingManagerMaster' className="inner-results-panel">
          <div className="section-results-header">
            <div className="section-header-title">
              <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
                <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
              </OverlayTrigger>
              <h4>{t(`${secMapMasters.title}`)}</h4>
              <Button
                id={'btn_add'}
                className="_Btn new"
                onClick={() => this.createProcessingManager()}>
                <i className='iDocIcon-add-plus'></i>{t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
              </Button>
            </div>
            <div className='filters'>
              <div className="search-form">
                <Field
                  component={InputText}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  name="filter.name"
                  controlLabel={t('MASTERS.NAME')}
                  placeholder={t('MASTERS.NAME')}
                  onInputChange={(value) => this.handleNameChange(value)}
                />
                <Field
                  component={InputSelect}
                  colWidth={50} // 25, 33, 50, 75, 100 default=25
                  name="filter.ouId"
                  controlLabel={t(`${tKey}UO`)}
                  placeholder={t(`${tKey}UO`)}
                  valueKey="id"
                  labelKey="value"
                  options={organizedUnitsAllCombo}
                  onInputChange={(value) => this.handleOrganizedUnitComboChange(value)}
                />
                <div className="search-form-actions flexInLine al-R">
                  <Button
                    className={'_Btn accept'}
                    onClick={() => this.search()}
                    onKeyDown={(e) => handleKeyDown(e)}>
                    <i className="ico-search" />
                    {t('MASTERS.SEARCH_BTN')}
                  </Button>
                  <Button
                    className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                    onClick={() => {
                      this.props.initialize({})
                      this.resetFilters()
                    }}>
                    <i className="ico-cancel" />
                    {t('MASTERS.RESET_BUTTON')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className='section-results-body'>
            <div className={'searchResoultsContainer'}>
              <div className="table-wrapper" key="table-wrapper">
                {/* table */}
                {(processingManagersSorted.length !== 0) &&
                  <Table className="editable-table" hover responsive>
                    <thead>
                      <tr>
                        <th className='td80per' onClick={() => { this.changeOrder('name') }}>
                          {t('MASTERS.NAME')}
                          <i className={this.getSortIcon('name')} />
                        </th>
                        <th onClick={() => { this.changeOrder('processingAgencyIds') }}>
                          {t(`${tKey}ASSOCIATED_PROCESSING_AGENCY`)}
                          <i className={this.getSortIcon('processingAgencyIds')} />
                        </th>
                        <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {processingManagersSorted && processingManagersSorted.map((processingManger, idx) => {
                        return (
                          <tr key={idx} className={processingManger.isDeleted ? 'is-deleted' : ''}>
                            <td>{processingManger.name}</td>
                            <td>{processingManger?.processingAgencyIds?.length || 0}</td>
                            <td className='actions'>
                              {!processingManger.isDeleted && (
                                <div>
                                  <OverlayTrigger placement="left" overlay={editTooltip}>
                                    <a className='_Btn accept stk o-icn' onClick={() => this.editProcessingManager(processingManger)}>
                                      <i className="iDocIcon-edit" />
                                    </a>
                                  </OverlayTrigger>
                                  <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                    <a className='_Btn cancel stk o-icn' onClick={() => this.deleteProcessingManager(processingManger)}>
                                      <i className="iDocIcon-delete-forever" />
                                    </a>
                                  </OverlayTrigger>
                                </div>
                              )}
                              {processingManger.isDeleted && (
                                <div>
                                  <OverlayTrigger placement="left" overlay={recoverTooltip}>
                                    <a className='_Btn accent stk o-icn' onClick={() => this.recoverProcessingManager(processingManger)}>
                                      <i className="iDocIcon-undo-back" />
                                    </a>
                                  </OverlayTrigger>
                                </div>
                              )}
                            </td>
                          </tr>)
                      })}
                    </tbody>
                  </Table>
                }
                {(processingManagersSorted === null || processingManagersSorted === undefined || processingManagersSorted.length === 0) &&
                  <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
                }
                <div className="section-users-footer">
                  <nav key={1} className="text-center">
                    <IDocCarPagination
                      id="btn_pag_sales"
                      page={page}
                      pagesCount={pagesCount}
                      totalRows={itemCount}
                      onSelectAction={(value) => this.searchTable(value)}
                    />
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <ProcessingManagerMasterPageModal/>
        </div>
      </>
    )
  }
}

export default reduxForm({
  form: 'processingManagerMaster'
})(ProcessingManagerMaster)
